import moment from 'moment';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { BsButton, BsForm, BsFormControl } from '../../collection/bootstrap/BootstrapComponents';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiForm, apiGet } from '../../utils/api';
import { swalert } from '../../utils/notifications';

export default function Fichaje(props) {
    const idFichaje = useParams().idFichaje;

    const updateData = async () => await apiGet("fichajes/get/" + idFichaje);
    const saveData = async data => {
        const result = await apiForm("fichajes/edit", data);
        if (result) {
            swalert("Guardado", "Comentario actualizado con éxito", "success");
        }
    }

    return <>
        <h2>Fichaje fuera de hora</h2>
        <BsForm
            isNew={false}
            onUpdate={updateData}
            onSave={saveData}>
            <FichajeForm />
        </BsForm>
    </>;
}

function FichajeForm(props) {
    const data = props.data;
    return <>
        <Row className="mt-2 gy-3">
            <HiddenInput name="trabajador" value={data.trabajador} />
            <Col md="6">
                <BsFormControl
                    /* Trabajador */
                    label="Trabajador" name="nombreTrabajador"
                    value={data.nombreTrabajador}
                    readOnly />
            </Col>
            <HiddenInput name="fechaHora" value={data.fechaHora} />
            <Col md="3">
                <BsFormControl
                    /* Fecha */
                    label="Fecha"
                    value={moment.utc(data.fechaHora).local().format("DD/MM/YY")}
                    readOnly />
            </Col>
            <Col md="3">
                <BsFormControl
                    /* Hora */
                    label="Hora"
                    value={moment.utc(data.fechaHora).local().format("HH:mm")}
                    readOnly />
            </Col>
            <Col md="12">
                <BsFormControl
                    /* Comentario */
                    label="Comentario" name="comentario"
                    value={data.comentario}
                    maxLength="250" as="textarea" />
            </Col>
        </Row>
        <div className="d-flex justify-content-center gap-3 mt-3">
            <BsButton onClick={props.onSubmit} isLoading={props.isSaving}>Guardar</BsButton>
        </div>
    </>;
}
